export default "__VITE_ASSET__B$LqGLnH__"